const columnRuleTypes = Object.freeze({
  'DIAS': 'DIAS ATRASO',
  'TEMPO': 'TEMPO ETAPA',
  'DIA_ESPECIFICO': 'DIA ATRASO ESPECIFICO'
})

export default columnRuleTypes



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/collumns/movimentacao-coluna/enumTiposRegra.js